
























import { Component, Vue } from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";
import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";
import { HsabExpenseFormMode } from "@/shared/types";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: {
    HsabExpenseForm
  }
})
export default class DebitCardTransactionModal extends Vue {
  themeStore = useThemeStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();

  get unusedDistribution () {
    return this.hsabExpenseFormStore.unusedDistribution;
  }

  get showModal () {
    return this.hsabExpenseFormStore.modalMode === HsabExpenseFormMode.debitCard;
  }
  handleOnEditClose () {
    this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.none);
  }
}
